import { css, SerializedStyles } from '@emotion/core'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'

interface Props {
  src: string
  alt: string
  boxed?: boolean
  className?: string
  css?: SerializedStyles | SerializedStyles[] | (undefined | SerializedStyles)[] | string
  loading?: `lazy` | `eager` | undefined
  placeholder?: 'dominantColor' | 'blurred' | 'tracedSVG' | 'none'
  imgStyle?: any
  skipGatsbyImage?: boolean
}

const Image: React.FunctionComponent<Props> = ({
  src,
  alt,
  boxed,
  className,
  css,
  imgStyle,
  loading,
  skipGatsbyImage,
}) => {
  const data = useStaticQuery(graphql`
    {
      images: allFile(filter: { relativePath: { regex: "/^content//" } }) {
        edges {
          node {
            relativePath
            name
            childImageSharp {
              gatsbyImageData(quality: 90, layout: FULL_WIDTH)
            }
            publicURL
          }
        }
      }
    }
  `)
  const image = data.images.edges.find((n: any) => n.node.relativePath === `content/${src}`)
  return image && image.node.childImageSharp && !skipGatsbyImage ? (
    <GatsbyImage
      image={image.node.childImageSharp.gatsbyImageData}
      alt={alt}
      css={[boxed && boxedContainerStyle, css]}
      className={className}
      imgStyle={imgStyle}
      loading={loading}
    />
  ) : image && image.node.publicURL ? (
    <img src={image.node.publicURL} alt={alt} css={[boxed && boxedContainerStyle, css]} className={className} />
  ) : null
}

export default Image

const boxedContainerStyle = css`
  border: 1px #efeff0 solid;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: rgb(0 0 0 / 8%) 0px 0.5rem 2rem;
  // temporary fix for Safari (overflow: hidden is disregarded otherwise)
  isolation: isolate;
`
